export const TOOLTIP_TEXT_FORECAST = 'This forecast is based on the price of recent trades.';
export const TOOLTIP_TEXT_CHANCE = 'These odds are based on what other people recently paid for Yes and No positions.';
export const TOOLTIP_TEXT_UNDERLYING =
    'Live market data and its recent changes are provided by a third-party data provider. Data may be delayed or stale.';
export const TOOLTIP_TEXT_COMMODITY_LIVE_DATA =
    'Price data is provided by a third-party source and may be delayed or contain errors.';
export const TOOLTIP_TEXT_LIVE_DATA =
    'Live data is provided by a third-party source and may be delayed or contain errors.';
export const TOOLTIP_TEXT_VOTEHUB_RACE_INTEL =
    'Data is provided by a third-party data provider and may be stale or inaccurate. Small donors is defined as contributions of $200 or less.';
export const TOOLTIP_TEXT_AI_DIGEST = 'AI-generated from public sources. May contain errors. Not trading advice.';
export const TOOLTIP_TEXT_ROI = 'Potential Return of Investment = ($1 payout - Investment) / Investment * 100%';
export const TOOLTIP_TEXT_LAST_TRADED = 'Forecasts are based on how much YES recently traded for';
export const TOOLTIP_TEXT_LAST_TRADED_AND_RECENT_CHANGE = 'Forecasts are based on how much YES recently traded for';
export const TOOLTIP_TEXT_TIMER_BADGE = 'Time until the market closes';
export const TOOLTIP_TEXT_VOLUME = 'Total event volume';
export const TOOLTIP_TEXT_BEST_BUY_YES = 'Best buy YES price';
export const TOOLTIP_TEXT_BEST_SELL_YES = 'Best sell YES price';
export const TOOLTIP_TEXT_BEST_BUY_NO = 'Best buy NO price';
export const TOOLTIP_TEXT_BEST_SELL_NO = 'Best sell NO price';
